import { render, staticRenderFns } from "./QViewCustomer.vue?vue&type=template&id=a0a1b662&"
import script from "./QViewCustomer.vue?vue&type=script&lang=js&"
export * from "./QViewCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports